import { nextTick } from "vue";

import { removeBoardScrollMargin } from "@/math/coordinate-utils";
import { fakeZoom } from "@/model/Settings";
import type { ZoomedRectangle } from "@/model/board";
import { pushZoomState } from "@/router/navigation";
import { useBoardSizeStore } from "@/store/boardSize";

export function applyFluidBoardRect(rect: ZoomedRectangle) {
  const rightBottom = useBoardSizeStore().rightBottomMargin;
  applyBoardRect({
    scale: rect.zoom / fakeZoom,
    top: rect.p0.y + "px",
    left: rect.p0.x + "px",
    height: rect.size.y + "px",
    width: rect.size.x + "px",
    right: rightBottom.x + "px",
    bottom: rightBottom.y + "px",
  });
}

export function applyFullBoardRect() {
  // Board needs to be downscaled, so we follow the pattern of fluid boards:
  // - first scale down x 0.1 here then scale back up x 10 in styling of individual full sized board
  // We need to keep this behavior to avoid bad-looking zooming in and out when switching
  // between boards during transition animation.
  applyBoardRect({
    scale: 1 / fakeZoom,
    top: "0",
    left: "0",
    height: "100%",
    width: "100%",
    bottom: "0",
    right: "0",
  });
}

function applyBoardRect(size: {
  scale: number;
  top: string;
  left: string;
  height: string;
  width: string;
  bottom: string;
  right: string;
}) {
  const boardElem = document.getElementById("boards");
  const borderElem = document.getElementById("boards-border");
  if (boardElem && borderElem) {
    const boardStyle = boardElem.style;
    boardStyle.transform = `scale(${size.scale})`;
    boardStyle.top = size.top;
    boardStyle.left = size.left;
    boardStyle.height = size.height;
    boardStyle.width = size.width;

    const borderStyle = borderElem.style;
    borderStyle.transform = `scale(${1 / size.scale})`;
    borderStyle.height = size.bottom;
    borderStyle.width = size.right;
  }
}

export function keepBoardScrollPos(action: () => void) {
  // wait to assure useBoardSizeStore().board.p0.x is applied to DOM
  void nextTick(() => {
    const scrollPos = window.scrollX - useBoardSizeStore().board.p0.x;
    action();
    void nextTick(() => {
      window.scrollTo({ left: scrollPos + useBoardSizeStore().board.p0.x });
      pushZoomState();
    });
  });
}

export function resetBoardScrollMargin() {
  if (!useBoardSizeStore().scrollableMarginLocked) {
    keepBoardScrollPos(removeBoardScrollMargin);
  } else {
    pushZoomState();
  }
}
